import { jsxs as e, jsx as o } from "react/jsx-runtime";

import s from "../hooks/useGlobals.js";

import a from "../../../utils/classNames/index.js";

const l = ({className: l, ...r}) => {
    const {model: t, components: n} = s();
    return e("table", {
        ...r,
        "aria-labelledby": t.ids.monthYear,
        role: "grid",
        className: a("w-full table-fixed text-center", l),
        children: [ o("thead", {
            children: o(n.DaysTableHeaderRows, {})
        }), o("tbody", {
            onKeyDown: t.handlers.keyDown,
            children: o(n.DaysTableBodyRows, {})
        }) ]
    });
};

export { l as default };
//# sourceMappingURL=DaysTable.js.map
